class s{constructor(){this.subscribers=[],this.subscribe=s=>(this.subscribers.push(s),()=>{const i=this.subscribers.indexOf(s);-1!==i&&this.subscribers.splice(i,1)}),this.publish=s=>{for(const i of this.subscribers)i(s)}}}export{s as PubSub};
//# sourceMappingURL=PubSub.js.map
